// extracted by mini-css-extract-plugin
var _1 = "o1MBJ";
export { _1 as "xSmallWarning" }
